module.exports = __webpack_public_path__ + "static/Boy.a0872349.png";